import request from "../config/axios-config";

export function getMenuCounters() {
    return (
        request({
            method: 'get',
            url: '/counter/menu'
        }))
}